import React from "react";
// import { redirect } from 'react-router-dom';

let logoutTimer;

export function login(token, expirationTime, firstTime) {
  localStorage.setItem('rxToken', token);
  localStorage.setItem('rxDemo', false);
  localStorage.setItem('rxExpTime', expirationTime);
  localStorage.setItem('rxFirstTime', firstTime ? 'first' : null);
  
  const remainingTime = calculateRemainingTime(expirationTime);

  logoutTimer = setTimeout(logout, remainingTime);
  console.log( '[LOGIN]', token, expirationTime);
}

export function logout() {
  localStorage.removeItem('rxToken');
  localStorage.removeItem('rxDemo');
  localStorage.removeItem('rxExpTime');
  localStorage.removeItem('rxFirstTime');
  if (logoutTimer) {
    clearTimeout(logoutTimer);
  }
  console.log('[LOGOUT]')
  //return redirect('/');
}


export function getTokenDuration() {
  const storedExpirationDate = localStorage.getItem('rxExpTime');
  const expirationDate = new Date(storedExpirationDate);
  const now = new Date();
  const duration = expirationDate.getTime() - now.getTime();
  return duration;
}

export function getAuthToken() {
  const token = localStorage.getItem('rxToken');
  if (!token) {
    console.log( "[GetAuthToken] no token")
    return null;
  }
  
  const tokenDuration = getTokenDuration();

  if (tokenDuration < 0) {
    console.log( "[GetAuthToken] Token expired")
    return null;
  }

  return token;
}

export function isLoggedIn() {
  return getAuthToken() !== null;
}


export function tokenLoader() {
  const token = getAuthToken();
  return token;
}

export function checkAuthLoader( redirect_to ) {
  const token = getAuthToken();

  if (!token) {
    //HACK: possible BUG, no redirect because of trouble with including redirect
    return // redirect( redirect_to );
  }
}

export function calculateRemainingTime( expirationTime ) {
  const currentTime = new Date().getTime();
  const adjExpirationTime = new Date(expirationTime).getTime();

  const remainingDuration = adjExpirationTime - currentTime;

  return remainingDuration;
}

export function isFirstLogin() {
  return localStorage.getItem('rxFirstTime') == 'first'; 
}

export function clearFirstLogin() {
  localStorage.setItem('rxFirstTime', null);
}